<template>
    <div v-if="settings.show">
        <b-modal v-model="popup"
                 :content-class=" 'custom-modal ' + (settings.sectionClass ? settings.sectionClass : '')">
            <template v-slot:modal-header>
                <span></span>
            </template>
            <div v-if="settings.show">
                <div class="modal-icon">
                    <img src="../../assets/icons/ic_cro.png">
                </div>
                <h2 class="modal-title">Confirm data</h2>
                <div class="modal-subtitle desc">Please confirm the following customer name is correct:</div>
                <div class="modal-subtitle cust_name">{{ settings.jobData.customer_name }}</div>
                <div class="checkboxes_wrapper">
<!--                    <div class="itemCheckbox">
                        <b-form-checkbox v-model="settings.updatePlacement"></b-form-checkbox>
                        <span>Update with new placement</span>
                    </div>-->
                    <div class="itemCheckbox">
                        <b-form-checkbox v-model="settings.dateInstallSensitive"></b-form-checkbox>
                        <span>Asset is portable</span>
                    </div>
                </div>
            </div>
            <template v-slot:modal-footer>
                <b-button variant="default" class="secondary" @click="onCancelClick">
                    {{ translate('Cancel') }}
                </b-button>

                <b-button variant="primary" :disabled="false" @click="onOkClick">
                    Confirm
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import _ from "lodash";

export default {
    name: "confirmCroJobPopup",
    data() {
        return {
            popup: _.isEmpty(this.settings),
        }
    },
    props: {
        settings: {
            type: [Object, null],
            default: () => {
                return {}
            }
        },
    },
    watch: {
        settings(newValue) {
            this.popup = !_.isEmpty(newValue)
        }
    },
    methods: {
        onOkClick() {
            this.popup = false
            this.settings.onOkHandler(this.settings.updatePlacement, this.settings.dateInstallSensitive)
        },
        onCancelClick() {
            this.popup = false
        },
    }
}
</script>

<style scoped>
.modal-header {
    visibility: hidden;
}
.checkboxes_wrapper {
    margin-top: 20px;
}

.itemCheckbox {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 6px;
}

.itemCheckbox span {
    margin-top: 4px;
    margin-left: 4px;
}

.modal-subtitle.desc {
    color: #474747;
}

.modal-subtitle {
    margin-top: 18px;
    text-align: left;
}

.cust_name {
    margin-top: 12px;
    color: #000000;
    font-style: italic;
    font-size: 17px;
}

.modal-title {
    margin-top: 8px;
}


.modal__remember {
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #2F2F2F;
    opacity: 0.7;
    margin-top: 41px;
    text-align: left;
}

.footer-ok__btn {
    background: #3F405C;
    border-radius: 6px;
    width: 100%;
    padding: 12px;
    color: white;
}
</style>